module.exports = __webpack_public_path__ + "img/limit_activity.b68d73da.png";